import React from 'react';
import logo from '../../../../images/logo_white.png';
import nick from '../../../../images/nick.png';
import { CustomLabel }  from "@tracknme/material-ui";
import ArrowForward from '@material-ui/icons/ArrowForward';
import { useSelector } from 'react-redux';
import '../../../../menu.css'

function MenuLeftStep2() {

  const { steps } = useSelector(({register}) => register);

  let porcent = '40%';
  
  if(steps === 5){
    porcent = '50%';
  }else if(steps === 6){
    porcent = '60%';
  }else if(steps === 7){
    porcent = '70%';
  }else if(steps === 8){
    porcent = '80%';
  }

  return (
    
         <div className="menuTop">          
            <div >
              <img src={logo} className="logoStep2" alt="logo"/>
            </div>
            <div className="wrapper" >
              <img src={nick} className="nickMenu" alt="logo"/>
            </div>

            
            <div className="menuBottom" >
                <div className="labelTitle">
                  <CustomLabel id="setup" label={"Cadastro "+porcent+" completo"} color="initial" component="h6" variant="h6" style={{fontSize:'2vh', fontWeight:'bold', color:"#FFFFFF"}} />  
                </div>
                <div className="progressBarFront">
                  {steps <= 5 &&(
                    <div style={{width:'20vh', height: '1.7vh', backgroundColor:"#F05423", borderTopLeftRadius:8, borderBottomLeftRadius:8}}></div>
                  )}
                  {steps === 6 &&(
                    <div style={{width:'25vh', height:'1.7vh', backgroundColor:"#F05423", borderTopLeftRadius:8, borderBottomLeftRadius:8}}></div>
                  )}
                  {steps === 7 &&(
                    <div style={{width:'30vh', height:'1.7vh', backgroundColor:"#F05423", borderTopLeftRadius:8, borderBottomLeftRadius:8}}></div>
                  )}
                  {steps === 8 &&(
                    <div style={{width:'35vh', height:'1.7vh', backgroundColor:"#F05423", borderTopLeftRadius:8, borderBottomLeftRadius:8}}></div>
                  )}
                </div>

                <div className="labelTitle">
                  <CustomLabel id="steps" label=" Próximos passos:" color="initial" component="h6" variant="h6" style={{fontSize:'2vh', fontWeight:'bold', color:"#FFFFFF"}} />  
                </div>

                <div style={{marginTop:'1.7vh',marginLeft:'5vh', width:'45vh', height:'7vh', backgroundColor:steps > 4 ? '#6A8DF3' : '#2E228C',display:'flex', flexDirection: 'row', justifyContent: 'left' }}>
                  <div><CustomLabel id="steps" label="Completar as informações da Empresa" color="initial" component="h6" variant="h6" style={{fontSize:'1.7vh', fontWeight:'700', color:steps > 4 ? "#FFFFFF" : "#BFBFBF", marginTop:'2.4vh', marginLeft:'2vh'}} />  </div>
                  <div style={{marginTop:'2.4vh', marginLeft:'6vh'}}><ArrowForward style={{color:'white'}}/></div>
                </div>

                <div style={{marginTop:'1.7vh',marginLeft:'5vh', width:'45vh', height:'7vh', backgroundColor: steps > 5 ? '#6A8DF3' : '#2E228C',display:'flex', flexDirection: 'row', justifyContent: 'left' }}>
                  <div><CustomLabel id="steps" label="Customizar as cores da sua plataforma" color="initial" component="h6" variant="h6" style={{fontSize:'1.7vh', fontWeight:'700', color:steps > 5 ? "#FFFFFF" : "#BFBFBF", marginTop:'2.4vh', marginLeft:'2vh'}} />  </div>
                  <div style={{marginTop:'2.4vh', marginLeft:'6vh'}}><ArrowForward style={{color:steps > 5 ? 'white' : '#BFBFBF'}}/></div>
                </div>

                <div style={{marginTop:'1.7vh',marginLeft:'5vh', width:'45vh', height:'7vh', backgroundColor:steps > 7 ? '#6A8DF3' : '#2E228C',display:'flex', flexDirection: 'row', justifyContent: 'left' }}>
                  <div><CustomLabel id="steps" label="Faça um Tour Guiado" color="initial" component="h6" variant="h6" style={{fontSize:'1.7vh',fontWeight:'700', color: steps > 7 ? "#FFFFFF" : "#BFBFBF", marginTop:'2.4vh', marginLeft:'2vh'}} />  </div>
                  <div style={{marginTop:'2.4vh', marginLeft:'20.5vh'}}><ArrowForward style={{color:steps > 7 ? 'white' : '#BFBFBF'}}/></div>
                </div>

            </div>

          {/* <div style={{height:"50%", width:"100%"}}>
            <img src={logo} className="logo" alt="logo" />
            <img src={nick} className="nickMenu" alt="logo"  style={{marginTop:'24%', marginLeft:'20%'}}/>
          </div> */}
          {/* <div style={{height:"50%", width:"100%", display:'flex',backgroundColor:"#3E2EBA",flexDirection:"column"}}>
          
              <div style={{marginTop:20,marginLeft:35}}>
                <CustomLabel id="setup" label={"Cadastro "+porcent+" completo"} color="initial" component="h6" variant="h6" style={{fontSize:16, fontWeight:'bold', color:"#FFFFFF"}} />  
              </div>
              <div style={{marginTop:15, marginLeft:35, width:352, height:14, flexDirection:"column", backgroundColor:"#EDEDED", borderRadius:8}}>
                {steps <= 5 &&(
                  <div style={{width:152, height:14, backgroundColor:"#F05423", borderTopLeftRadius:8, borderBottomLeftRadius:8}}></div>
                )}
                {steps === 6 &&(
                  <div style={{width:200, height:14, backgroundColor:"#F05423", borderTopLeftRadius:8, borderBottomLeftRadius:8}}></div>
                )}
                 {steps === 7 &&(
                  <div style={{width:250, height:14, backgroundColor:"#F05423", borderTopLeftRadius:8, borderBottomLeftRadius:8}}></div>
                )}
                 {steps === 8 &&(
                  <div style={{width:300, height:14, backgroundColor:"#F05423", borderTopLeftRadius:8, borderBottomLeftRadius:8}}></div>
                )}
              </div>

              <div style={{marginTop:15,marginLeft:35}}>
                <CustomLabel id="steps" label=" Próximos passos:" color="initial" component="h6" variant="h6" style={{fontSize:16, fontWeight:'bold', color:"#FFFFFF"}} />  
              </div>

              <div style={{marginTop:15,marginLeft:35, width:352, height:56, backgroundColor:steps > 4 ? '#6A8DF3' : '#2E228C',display:'flex', flexDirection: 'row', justifyContent: 'left' }}>
                <div><CustomLabel id="steps" label="Completar as informações da Empresa" color="initial" component="h6" variant="h6" style={{fontSize:14, fontWeight:'700', color:steps > 4 ? "#FFFFFF" : "#BFBFBF", marginTop:17, marginLeft:15}} />  </div>
                <div style={{marginTop:17, marginLeft:35}}><ArrowForward style={{color:'white'}}/></div>
              </div>

              <div style={{marginTop:15,marginLeft:35, width:352, height:56, backgroundColor: steps > 5 ? '#6A8DF3' : '#2E228C',display:'flex', flexDirection: 'row', justifyContent: 'left' }}>
                <div><CustomLabel id="steps" label="Customizar as cores da sua plataforma" color="initial" component="h6" variant="h6" style={{fontSize:14, fontWeight:'700', color:steps > 5 ? "#FFFFFF" : "#BFBFBF", marginTop:17, marginLeft:15}} />  </div>
                <div style={{marginTop:17, marginLeft:35}}><ArrowForward style={{color:steps > 5 ? 'white' : '#BFBFBF'}}/></div>
              </div>

              <div style={{marginTop:15,marginLeft:35, width:352, height:56, backgroundColor:steps > 7 ? '#6A8DF3' : '#2E228C',display:'flex', flexDirection: 'row', justifyContent: 'left' }}>
                <div><CustomLabel id="steps" label="Faça um Tour Guiado" color="initial" component="h6" variant="h6" style={{fontSize:14, fontWeight:'700', color: steps > 7 ? "#FFFFFF" : "#BFBFBF", marginTop:17, marginLeft:15}} />  </div>
                <div style={{marginTop:17, marginLeft:155}}><ArrowForward style={{color:steps > 7 ? 'white' : '#BFBFBF'}}/></div>
              </div>

          </div> */}
           
        </div>
        


  );
}

export default MenuLeftStep2;

